<!-- dialog to start new sales order or purchase order -->
<p-dialog [style]="{ width: '656px',padding:'10px !important' }" [breakpoints]="{ '960px': '75vw', '640px': '97vw' }"
    [baseZIndex]="10000" [modal]="true" [header]="modalheaderName + ' ' + orderNo" [(visible)]="display"
    [draggable]="false" [closable]="true" (onHide)="cancel()" class="transM">
    <div class="wrapper">

        <div class="w-50 my-2">
            <p-dropdown [options]="roles" class="w-100" placeholder="Please Select your Role" optionLabel="name"
                (onChange)="handleRoleChange($event)" #Role [(ngModel)]="roleDdval"></p-dropdown>
            <small class="text-danger" *ngIf="isRoleExist">
                Please Select Role
            </small>
        </div>
        <div class="orderInfo seller mobile">

            <div class="user d-flex align-items-center justify-content-between ">
                <div class="sellerHeader">
                    <span>Order Information</span>
                </div>
            </div>
            <form [formGroup]="orderForm" class="form mt-3  calendar-form">
                <div class="row">
                    <div class="col-12 col-md-6 pt-4">
                        <div class="mb-3 pt-2">
                            <div class="enter d-flex align-items-center justify-content-start gap-2">
                                <span class="mr-2 spEnterd">Entered By :</span>
                                <a class="enteredBy" rel="noopener noreferrer">{{
                                    fullName
                                    }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Reference #
                            </label>
                            <input type="text" class="form-control" placeholder="Enter Transaction Reference #"
                                formControlName="reference" />



                        </div>
                    </div>


                </div>
            </form>
        </div>
        <div class="seller mobile">
            <div class="sellerHeader">
                <span>Buyer Information</span>
            </div>
            <form [formGroup]="orderForm" class="form ">
                <div class="row">
                    <div class="col-md-12">
                        <div class="flex align-items-center gap-1 temm" *ngIf="formType?.toUpperCase() != 'PO'">

                            <input type="checkbox" name="istemp" class="m-2" formControlName="istemp"
                                (click)="selectTempBuyer()" />
                            <label for="ny" class="p-0 mb-0">Temp Account</label>
                        </div>
                    </div>
                    <!-- buyer company Name -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Buyer Company Name*</label>
                            <div *ngIf="isBuyerTempAccount || isCompantIdExist">
                                <input [readonly]="
                                        !isBuyerTempAccount && isCompantIdExist
                                    " type="text" name="Buyer Company Name" class="form-control"
                                    placeholder="Buyer Company Name..." formControlName="buyerCompanyName" />
                            </div>

                            <div *ngIf="!isCompantIdExist">
                                <p-dropdown *ngIf="!isBuyerTempAccount" [options]="buyerCompanies"
                                    formControlName="buyerCompanyName" [filter]="true" optionLabel="name"
                                    placeholder="Please Select Buyer Company Name" (onFilter)="
                                        handleBuyerCompanySearch($event)
                                    " (onChange)="
                                        handleBuyerCompanyChange($event)
                                    " required></p-dropdown>
                            </div>
                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('buyerCompanyName')
                                        ?.hasError('required')
                                ">
                                Buyer company Name is required
                            </small>
                        </div>
                    </div>
                    <!-- buyer company Name -->

                    <!-- buyer name -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Buyer Contact Name</label>
                            <input type="text" name="" id="" class="form-control" placeholder="Buyer Contact Name"
                                formControlName="buyerContactName" *ngIf="isBuyerTempAccount" />


                            <div>



                                <p-autoComplete #autoComplete [dropdown]="true" *ngIf="!isBuyerTempAccount" [ngClass]="isArabic? 'rtl-autoC':'ltr-autoC'"
                                    [suggestions]="filteredBuyerContacts" formControlName="buyerContactName"
                                    [(ngModel)]="selectedBuyerContact" (completeMethod)="handleBuyerNameSearch($event)"
                                    (ngModelChange)="handleBuyerNameChange($event)" (click)="loadInitialContacts()"
                                    [placeholder]=" 'Please Select Buyer Name'" field="name" [forceSelection]="false">

                                    <ng-template pTemplate="empty">
                                        <div *ngIf="buyerContacts.length === 0" class="no-data">
                                            No data found
                                        </div>
                                    </ng-template>
                                </p-autoComplete>




                            </div>



                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('buyerContactName')
                                        ?.hasError('required')
                                ">
                                Buyer Name is required
                            </small>
                        </div>
                    </div>
                    <!-- buyer name -->

                    <!-- buyer number -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">{{buyerPhoneLabel}}
                            </label>
                            <input type="text" class="form-control" placeholder="Buyer Phone Number..."
                                formControlName="buyerContactPhoneNumber" minlength="5" maxlength="20" [ngClass]="{
                                    'is-invalid': orderForm.controls['buyerContactPhoneNumber'].invalid && orderForm.controls['buyerContactPhoneNumber'].touched
                                  }" />
                            <small class="text-danger" *ngIf="invalidBuyerPhoneNumber && !orderForm
                                .get('buyerContactPhoneNumber')
                                ?.hasError('required')">
                                {{ invalidBuyerPhoneNumber }}
                            </small>


                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('buyerContactPhoneNumber')
                                        ?.hasError('pattern')
                                ">
                                phone Number is Invalid
                            </small>
                        </div>
                    </div>
                    <!-- buyer number -->

                    <!-- buyer email -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Buyer Email
                            </label>
                            <input type="email" name="" id="" class="form-control" placeholder="Buyer Email..."
                                formControlName="buyerContactEMailAddress" minlength="5" maxlength="100" [ngClass]="{
                                    'is-invalid': orderForm.controls['buyerContactEMailAddress'].invalid && orderForm.controls['buyerContactEMailAddress'].touched
                                  }" />

                            <small class="text-danger" *ngIf="invalidBuyerContactEMailAddress &&
                                   ! orderForm
                                        .get('buyerContactEMailAddress')
                                        ?.hasError('email')">
                                {{ invalidBuyerContactEMailAddress }}
                            </small>
                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('buyerContactEMailAddress')
                                        ?.hasError('email')
                                ">
                                Email Address is Invalid
                            </small>
                        </div>
                    </div>
                    <!-- buyer email -->
                    <!-- buyer company branch -->

                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Branch*</label>
                            <div>
                                <p-dropdown class="custom-dropdown" [ngClass]="{
                                    'addDanger': submitted && orderForm.get('buyerCompanyBranch')?.hasError('required')
                                }" *ngIf="!isBuyerTempAccount" [options]="buyerBranches"
                                    formControlName="buyerCompanyBranch" [filter]="true" optionLabel="name"
                                    placeholder="Please Select Branch" [required]="!isBuyerTempAccount"></p-dropdown>

                                <small class="text-danger"
                                    *ngIf="submitted && orderForm.get('buyerCompanyBranch')?.hasError('required')">
                                    Branch is required
                                </small>

                            </div>
                            <input type="text" name="" id="" [value]="'Main'" readonly class="form-control"
                                placeholder="Main" formControlName="buyerBranchName" *ngIf="isBuyerTempAccount" />


                        </div>
                    </div>
                    <!-- buyer company branch -->

                    <!--price level and currency  -->

                    <div class="col-md-6 d-flex price-sec" *ngIf="isBuyerTempAccount">





                        <div class="mb-3 w-100">
                            <label for="" class="form-label"> {{l("Currency")}}</label>
                            <div>
                                <p-dropdown [options]="allCurrencies" (onChange)="changeTouchState($event)"
                                    [(ngModel)]="accountInfoTemp.currencyId" formControlName="currencyId"
                                    [placeholder]="this.appSession.tenant.currencyInfoDto.label"></p-dropdown>

                            </div>

                            <small class="text-danger" *ngIf="
                                                            submitted &&
                                                            orderForm
                                                                .get('currencyId')
                                                                ?.hasError('required')
                                                        ">
                                Currency is required
                            </small>
                        </div>


                        <div class="mb-3 w-100">
                            <label for="" class="form-label">{{l("PriceLevel")}}</label>
                            <div>
                                <p-dropdown [options]="allPriceLevel" [(ngModel)]="accountInfoTemp.priceLevel"
                                    formControlName="priceLevel" (change)="changePrice($event)"
                                    [placeholder]="languageSettingName!='en-GB' ? 'MSRP' : 'RRP'"></p-dropdown>
                            </div>

                            <small class="text-danger" *ngIf="
                                                                            submitted &&
                                                                            orderForm
                                                                                .get('priceLevel')
                                                                                ?.hasError('required')
                                                                        ">
                                Price Level is required
                            </small>
                        </div>
                        <!-- price level and currency -->
                    </div>

                    <!-- price level and currency -->
                </div>
            </form>
        </div>
        <div class="seller mobile">
            <div class="sellerHeader">
                <span>Seller Information</span>
            </div>
            <form class="form mt-3" [formGroup]="orderForm">
                <div class="row " [ngClass]="isArabic?'calendar-form-ar':'calendar-form'">

                    <!-- Seller company Name -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Seller Company Name*</label>
                            <div *ngIf="isSellerCompanyIdExist">
                                <input type="text" name="sellerCompanyName" class="form-control"
                                    placeholder="seller Company Name..." formControlName="sellerCompanyName" readonly />
                            </div>
                            <div *ngIf="!isSellerCompanyIdExist">
                                <p-dropdown [options]="sellerCompanies" formControlName="sellerCompanyName"
                                    [filter]="true" optionLabel="name" placeholder="Please Select Seller Company Name"
                                    (onFilter)="
                                        handleSellerCompanySearch($event)
                                    " (onChange)="
                                        handleSellerCompanyChange($event)
                                    " required></p-dropdown>
                            </div>

                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('sellerCompanyName')
                                        ?.hasError('required')
                                ">
                                Seller company Name is required
                            </small>
                        </div>
                    </div>
                    <!-- Seller company Name -->

                    <!-- seller Name -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Seller Contact Name</label>

                            <p-autoComplete #autoComplete [dropdown]="true" [suggestions]="filteredSellerContacts" [ngClass]="isArabic? 'rtl-autoC':'ltr-autoC'"
                                formControlName="sellerContactName" [(ngModel)]="selectedSellerContact"
                                (completeMethod)="handleSellerNameSearch($event)"
                                (ngModelChange)="handleSellerNameChange($event)" (click)="loadInitialSellerContacts()"
                                [placeholder]=" 'Please Select Seller Contact Name'" field="name"
                                [forceSelection]="false">


                            </p-autoComplete>

                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('sellerContactName')
                                        ?.hasError('required')
                                ">
                                Seller Name is required
                            </small>
                        </div>
                    </div>
                    <!-- seller Name -->

                    <!-- phone Number -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">{{sellerPhoneLabel}}
                            </label>
                            <input type="text" name="mobileNumber" class="form-control" placeholder="Phone Number..."
                                formControlName="sellerContactPhoneNumber" minlength="5" maxlength="20" [ngClass]="{
                                    'is-invalid': orderForm.controls['sellerContactPhoneNumber'].invalid && orderForm.controls['sellerContactPhoneNumber'].touched
                                  }" />

                            <small class="text-danger" *ngIf="invalidSellerPhoneNumber && !orderForm
                                .get('sellerContactPhoneNumber')
                                ?.hasError('required')">
                                {{ invalidSellerPhoneNumber }}
                            </small>
                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('sellerContactPhoneNumber')
                                        ?.hasError('pattern')
                                ">
                                phone Number is Invalid
                            </small>
                        </div>
                    </div>
                    <!-- seller Phone number -->

                    <!-- Seller email -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Seller Email</label>
                            <input type="email" name="sellerContactEMailAddress" class="form-control"
                                placeholder="Seller Email..." formControlName="sellerContactEMailAddress" minlength="5"
                                maxlength="100" [ngClass]="{
                                    'is-invalid': orderForm.controls['sellerContactEMailAddress'].invalid && orderForm.controls['sellerContactEMailAddress'].touched
                                  }" />
                            <small class="text-danger" *ngIf="invalidSellerContactEMailAddress  && 
                                ! orderForm
                                     .get('sellerContactEMailAddress')
                                     ?.hasError('email')">
                                {{ invalidSellerContactEMailAddress }}
                            </small>
                            <small class="text-danger" *ngIf="
                                    submitted &&
                                    orderForm
                                        .get('sellerContactEMailAddress')
                                        ?.hasError('email')
                                ">
                                Email Address is Invalid
                            </small>
                        </div>
                    </div>
                    <!-- Seller email -->
                    <!-- buyer company branch -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="" class="form-label">Branch*</label>
                            <div>
                                <p-dropdown [ngClass]="{
                                        'addDanger': submitted && orderForm.get('sellerCompanyBranch')?.hasError('required')
                                    }" [options]="sellerBranches" formControlName="sellerCompanyBranch" [filter]="true"
                                    optionLabel="name" placeholder="Please Select Branch" (onFilter)="
                                            handleBuyerCompanySearch($event)
                                        " required></p-dropdown>
                            </div>

                            <small class="text-danger" *ngIf="
                                                    submitted &&
                                                    orderForm
                                                        .get('sellerCompanyBranch')
                                                        ?.hasError('required')
                                                ">
                                Branch is required
                            </small>
                        </div>
                    </div>
                    <!-- seller company branch -->
                    <div class="col-12 my-2">
                        <div *ngIf="areSame" class="alert alert-danger" role="alert">
                            <p class="mb-0">
                                Buyer and Seller are same person please choose another option
                            </p>
                        </div>
                    </div>


                    <div class="col-12 col-md-6 ">
                        <div class="mb-3 ">
                            <label class="form-label">Entered Date*</label>
                            <div class="position-relative">

                                <p-calendar #calendar1 [appendTo]="'body'" formControlName="enteredDate" [dateFormat]="primeDateFormat" 
                                    [showIcon]="true" [readonlyInput]="false" 
                                    (ngModelChange)="changeEnteredDate(orderForm.get('enteredDate'))"
                                   [showOtherMonths]="true"
                                    [selectOtherMonths]="true"></p-calendar>
                                <img src="../../../../../assets/icons/calendar.png" (click)="openCalendar(calendar1)"
                                    alt="" srcset="">
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mb-3 ">
                            <label class="form-label">Start Date*</label>
                            <div class="position-relative">
                                <p-calendar #calendar2 [appendTo]="'body'" #calendar formControlName="startDate" [dateFormat]="primeDateFormat" 
                                    [showIcon]="true" (ngModelChange)="changeStartDate(orderForm.get('startDate'))"
                                    [readonlyInput]="false" [minDate]="minSEnteredDate" [showOtherMonths]="true"
                                    [selectOtherMonths]="true"></p-calendar>
                                <img (click)="openCalendar(calendar2)" src="../../../../../assets/icons/calendar.png"
                                    alt="" srcset="">


                            </div>

                            <small class="text-danger" *ngIf="
                               
                            submitted &&  startDateMsg
                            ">
                                start date Can’t be befor the Entered date
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mb-3 relative">
                            <label class="form-label">Complete Date*</label>
                            <div class="position-relative">

                                <p-calendar #calendar3 [appendTo]="'body'" formControlName="completeDate" [dateFormat]="primeDateFormat" 
                                    [showIcon]="true" [minDate]="minStartDate" [readonlyInput]="false"
                                    (ngModelChange)="changeCompleteDate(orderForm.get('completeDate'))"
                                    [showOtherMonths]="true" [selectOtherMonths]="true"></p-calendar>
                                <img (click)="openCalendar(calendar3)" src="../../../../../assets/icons/calendar.png"
                                    alt="" srcset="">
                            </div>
                            <small class="text-danger" *ngIf="
                               
                            submitted &&  comtDateMsg
                            ">
                                Complete date Can’t be before the Start date
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="mb-3 ">
                            <label class="form-label">Available Date*</label>
                            <div class="position-relative">

                                <p-calendar #calendar4 [appendTo]="'body'" formControlName="availableDate" [dateFormat]="primeDateFormat" 
                                    [showIcon]="true" [readonlyInput]="false"
                                    (ngModelChange)="changeAvailbeDate(orderForm.get('availableDate'))"
                                    [showOtherMonths]="true" [selectOtherMonths]="true"
                                    [minDate]="minCompleteDate"></p-calendar>
                                <img (click)="openCalendar(calendar4)" src="../../../../../assets/icons/calendar.png"
                                    alt="" srcset="">
                            </div>
                        </div>
                        <small class="text-danger" *ngIf="
                           
                        submitted &&  avalabletDateMsg
                        ">
                            Available date Can’t be before the complete date
                        </small>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">
        <button pButton [loading]="btnLoader" (click)="getStarted()" class=" btn-c">
            Start Shopping
        </button>
    </div>
</p-dialog>
<app-transaction-information #shoppingCartModal></app-transaction-information>
<report-viewer class="w-100 d-none" [reportUrl]="reportUrl" [invokeAction]="invokeAction">
</report-viewer>